import { AccountingPackage } from './accounting-package.model';

export enum AccountingPackageTypeEnum {
  None = 0,
  Quickbooks = 1,
  MicrosoftDynamicsGP = 2,
  Intacct = 3,
  QuickbooksOnline = 4,
}
